export default "__VITE_ASSET__0ed6dd09__"